const CategoriesRoutes = {
  create: "categories/create",
  getCategory: "categories",
  deleteCategory: "categories/delete",
  updatedCategory: "categories/update",
};

export default CategoriesRoutes